import { Color } from '@tmh-website/shared/colors';

import * as Styled from './LoadingSpinner.styles';

export interface LoadingSpinnerProps {
  size?: number;
  spinnerSize?: number;
  borderWidth?: number;
  color?: Color;
  /**
   * Position the loading spinner absolute and in the center
   */
  absolutePosition?: boolean;
  /**
   * Force the spinner to have no margin
   */
  noMargin?: boolean;
}

const LoadingSpinner = ({
  size = 16,
  spinnerSize = 16,
  borderWidth = 2,
  color = Color.Blue_1000_Deep,
  absolutePosition,
  noMargin,
  ...props
}: LoadingSpinnerProps) => {
  return (
    <Styled.Container $size={size} $absolutePosition={!!absolutePosition} $noMargin={!!noMargin} {...props}>
      <Styled.Spinner $spinnerSize={spinnerSize} $color={color} $borderWidth={borderWidth} />
    </Styled.Container>
  );
};

export default LoadingSpinner;
